import React from "react";
import css from "./Home.module.css";

const Home = () => {
	return (
		<section className={css.home}>
			<h2>Home</h2>
			<p>Home page</p>
		</section>
	);
};

export default Home;
